
import { Component, Mixins } from 'vue-property-decorator'
// import data from './data.js'
import CModal from '@/components/modal'
import { messages } from './i18n'
import { NotificationService, MediasService } from '@/@next/services'
import cloneDeep from 'lodash/cloneDeep'
import parser from 'cron-parser'
import { Maybe, MediaImage } from '@/@types/graphql'
import { CLazyLoadingImage } from '@/components/images'
import { CLoader } from '@/components/loader'
import { CButton } from '@/components/form-controls/button'

const config = {
  name: 'c-notification',
  components: { ...CModal, CLazyLoadingImage, CLoader, CButton },
  i18n: { messages }
}

@Component(config)
export default class CNotification extends Mixins(NotificationService, MediasService) {

  notifications: any = []
  notificationTimer: any
  current: any = null
  showNotification: boolean = false
  startTime = Date.now()
  image: Maybe<MediaImage> = null

  notify () {
    this.showNotification = true
    // window.navigator.vibrate(200)
  }

  closeNotification () {
    this.showNotification = false 
    this.resetTimer()
  }

  resetTimer () {
    if (this.notificationTimer) clearTimeout(this.notificationTimer)
    this.findCurrent()
    if (!this.current) return
    console.log('Current notification :', this.current)
    const currentTime = new Date().getTime()
    const date = new Date(this.current.date)  
    const deltaMs = date.getTime() - currentTime
    if (deltaMs > 0) {
      this.notificationTimer = setTimeout(() => {
        this.notify()
      }, deltaMs)
    }
  }

  computeTrigger (notification: any) {
    switch (notification.type) {
      case 'delay': const date = new Date(this.startTime + notification.delay * 1000);
                    notification.deltaMs = date.getTime() - Date.now()
                    notification.date = date.toISOString()
                    console.log('delay notification :', notification)
                    break
      case 'date': const event = new Date(notification.date)  
                   notification.deltaMs = event.getTime() - Date.now()
                   console.log('Date notification :', notification)
                   break
      case 'cron': const interval = parser.parseExpression(notification.expression, { currentDate: new Date() })
                   console.log('Cron notification :', notification)
                   console.log('Cron interval: ' + interval)
                   const next = interval.next()
                   console.log('next: ' + next)
                   notification.deltaMs = next.getTime() - Date.now()
                   console.log('delay: ' + notification.deltaMs)
                   notification.date = next.toISOString()
                   console.log('date: ' + notification.date)
                   break
      default: break
    }
    return notification
  }

  findCurrent () {
    if (!this.notifications || !Array.isArray(this.notifications)) return console.info('[Info][Notifications] There is no notifications programmed')
    const removeOldNotifications = (n: any) => n.deltaMs && n.deltaMs > -1
    const sortByTime = (a: any, b: any) => a.deltaMs > b.deltaMs ? 1 : -1
    const ordered = this.notifications
                          .map(this.computeTrigger)
                          .filter(removeOldNotifications)
                          .sort(sortByTime)
    if (ordered.length) this.current = cloneDeep(ordered[0])
    else this.current = null
    this.fetchImage()
  }

  async init () {
    this.notifications = await this.GET_NOTIFICATION()
    // this.notifications = [
    //   {
    //     id: '351771ae-f407-41e0-a5f1-9d4cd622a732',
    //     date: null,
    //     name: 'cron',
    //     text: [
    //       {
    //         value: {
    //           html: '<p>cron</p>',
    //           text: 'cron'
    //         },
    //         target: null,
    //         language: 'fr'
    //       }
    //     ],
    //     type: 'cron',
    //     delay: 30,
    //     title: [
    //       {
    //         value: {
    //           html: '<p>Cron</p>',
    //           text: 'Cron'
    //         },
    //         target: null,
    //         language: 'fr'
    //       }
    //     ],
    //     imageId: '1298f594-a893-45f7-a716-3ed5a3bff22b',
    //     languages: [
    //       'fr'
    //     ],
    //     expression: '*/10 * * * * *'
    //   },
    //   {
    //     id: '351771ae-f407-41e0-a5f1-9d4cd622a730',
    //     date: null,
    //     name: '15s',
    //     text: [
    //       {
    //         value: {
    //           html: '<p>notification 15s</p>',
    //           text: 'notification 15s'
    //         },
    //         target: null,
    //         language: 'fr'
    //       }
    //     ],
    //     type: 'delay',
    //     delay: 15,
    //     title: [
    //       {
    //         value: {
    //           html: '<p>15s</p>',
    //           text: '15s'
    //         },
    //         target: null,
    //         language: 'fr'
    //       }
    //     ],
    //     imageId: '1298f594-a893-45f7-a716-3ed5a3bff22b',
    //     languages: [
    //       'fr'
    //     ],
    //     expression: null
    //   },
    //   {
    //     id: '51a1fe15-47a6-4782-a5a3-3eb6c05f6657',
    //     date: '2022-05-12T17:12:00.000+02:00',
    //     name: '16h48',
    //     text: [
    //       {
    //         value: {
    //           html: '',
    //           text: ''
    //         },
    //         target: null,
    //         language: 'fr'
    //       }
    //     ],
    //     type: 'date',
    //     delay: 30,
    //     title: [
    //       {
    //         value: {
    //           html: '<p>16h48</p>',
    //           text: '16h48'
    //         },
    //         target: null,
    //         language: 'fr'
    //       }
    //     ],
    //     imageId: null,
    //     languages: [
    //       'fr'
    //     ],
    //     expression: null
    //   }
    // ]
    this.resetTimer()      
  }

  async mounted () {
    await this.init()
  }

  beforeDestroy () {
    this.notifications = []
    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer)
    }
  }

  findTranslation (text: any) {
      if (!text?.length) return null
      const translation = text.find((el: any) => el.language === this.$i18n.locale)
      if (translation) return translation.value.html
      const french = text.find((el: any) => el.language === 'fr')
      if (french) return french?.value.html
      return null
  }

  async fetchImage () {
    if (!this.current?.imageId) return
    this.image = await this.GET_SINGLE_IMAGE(this.current?.imageId)
  }
}
